import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DeliveryWorkerContext from "../../../context/delivery-worker/context";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { IDeliveryWorker } from "../../../models/delivery-workers/response";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Space from "../../general/antd/space";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import ViewBtn from "../../general/table-components/actions/view-btn";
import Table from "../../general/table-components/table";
import Tag from "../../general/antd/tag";
import {
  getStatusDeliveryWorker,
  getStatusDeliveryWorkerColor,
  getVehicleType,
} from "../../../models/delivery-workers/enum";
import { getUserStatus, getUserStatusColor } from "../../../models/user/enum";
import moment from "moment";
import Popconfirm from "../../general/antd/pop-confirm";
import Button from "../../general/antd/button";
import { Dropdown } from "antd";
import AppContext from "../../../context/app/context";
import { MoreOutlined } from "@ant-design/icons";
interface IProps { }

const DeliveryWorkerTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(DeliveryWorkerContext);
  const { screenSize } = useContext(AppContext);

  const columns: ColumnProps<IDeliveryWorker>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("first_name"),
      dataIndex: "firstName",
      //width: 200,
      sorter: {
        multiple: 2,
      },
      align: "center",
      key: "firstName",
      render: (_, record) => {
        return <>{record?.user?.firstName ?? "-"}</>;
      },
    },
    {
      title: t("last_name"),
      dataIndex: "lastName",
      //width: 200,
      sorter: {
        multiple: 3,
      },
      align: "center",
      key: "lastName",
      render: (_, record) => {
        return <>{record?.user?.lastName ?? "-"}</>;
      },
    },
    {
      title: t("status_worker"),
      dataIndex: "statusWorker",
      //width: 200,
      sorter: {
        multiple: 4,
      },
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getStatusDeliveryWorker(record?.statusWorker)}
            color={getStatusDeliveryWorkerColor(record?.statusWorker)}
          />
        );
      },
    },
    {
      title: t("status"),
      dataIndex: "status",
      // width: 200,
      align: "center",
      key: "status",
      render: (_, record) => {
        return (
          <Tag
            title={getUserStatus(record?.user?.status)}
            color={getUserStatusColor(record?.user?.status)}
          />
        );
      },
    },
    {
      title: t("vehicle_type"),
      dataIndex: "vehicleType",
      //width: 200,
      sorter: {
        multiple: 4,
      },
      align: "center",
      key: "vehicleType",
      render: (_, record) => {
        return (
          <Tag
            title={getVehicleType(record?.vehicleType)}
          />
        );
      },
    },
    {
      title: t("mobile"),
      dataIndex: "mobile",
      key: "mobile",
      align: "center",
      render: (_, record) => {
        return <>{record?.user?.cleanMobile}</>;
      },
    },
    {
      title: t("wallet"),
      dataIndex: "wallet",
      key: "wallet",
      align: "center",
      sorter: {
        multiple: 5,
      },
    },
    {
      title: t("debt"),
      dataIndex: "debt",
      key: "debt",
      align: "center",
      sorter: {
        multiple: 7,
      },
    },
    {
      title: t("number_ignore"),
      dataIndex: "numberIgnore",
      key: "numberIgnore",
      align: "center"
    },
    {
      title: t("city"),
      dataIndex: "city",
      key: "city",
      align: "center",
      render: (_, record) => {
        return <>{record?.city?.name}</>;
      },
    },
    {
      title: t("store"),
      dataIndex: "store",
      key: "store",
      align: "center",
      sorter: {
        multiple: 8,
      },
      render: (_, record) => {
        return <>{record?.store?.name ?? "-"}</>;
      },
    },
    {
      title: t("driver_classification"),
      dataIndex: "driverClassification",
      key: "driverClassification",
      align: "center",
      render: (_, record) => {
        return <>{record?.driverClassification?.name ?? "-"}</>;
      },
    },
    {
      title: t("created_at"),
      dataIndex: "createdAt",
      align: "center",
      sorter: {
        multiple: 6,
      },
      key: "createdAt",
      render: (_, record) => {
        return moment(record?.createdAt).format("YYYY-MM-DD");
      },
    },
    {
      title: t("actions"),
      width: screenSize != 'mobileOrTablet' ? 240 : 90,
      dataIndex: "",
      align: "center",
      fixed: "right",
      key: "x",
      render: (_: any, record) => (
        screenSize === 'mobileOrTablet' ? (
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: 'view',
                  label: (
                    <Button
                      type="link"
                      onClick={(e) => {
                        const url = `details/${record?.id}`;
                        if (e.ctrlKey || e.metaKey) {
                          window.open(url, "_blank");
                        } else {
                          navigate(url);
                        }
                      }}
                    >
                      {t("view")}
                    </Button>
                  ),
                },
                {
                  key: 'edit',
                  label: (
                    <Button
                      type="link"
                      onClick={(e) => {
                        const url = `update/${record?.id}`;
                        if (e.ctrlKey || e.metaKey) {
                          window.open(url, "_blank");
                        } else {
                          navigate(url);
                        }
                      }}
                    >
                      {t("edit")}
                    </Button>
                  ),
                },
                {
                  key: 'delete',
                  label: (
                    <Popconfirm
                      title={t("confirm")}
                      onConfirm={async () => {
                        await actions.deleteDeliveryWorker(record?.id);
                        eventManager.emit(EVENT_SUCCESS);
                      }}
                    >
                      <Button type="link" danger>
                        {t("delete")}
                      </Button>
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        ) : (
          <Space>
            <ViewBtn
              onClick={(e) => {
                const url = `details/${record?.id}`;
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
            <EditBtn
              onClick={(e) => {
                const url = `update/${record?.id}`;
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
            <DeleteBtn
              onConfirm={async () => {
                await actions.deleteDeliveryWorker(record?.id);
                eventManager.emit(EVENT_SUCCESS);
              }}
              loading={loading.includes("delete")}
            />
          </Space>
        )
      ),
    }
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        scroll={{
          x: 1850,
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default DeliveryWorkerTable;
